import { styled } from '@linaria/react';
import { fonts, layout, primitives, radius, semantic, size, space } from '../../theme/tokens';

const fieldHeight = `calc(${primitives.size['size-1000']} + ${space['space-400']} * 2)`;

export const SelectShell = styled.div`
  & > * {
    background: ${semantic.bg.canvas};
    border-radius: ${radius('input', 'radius-md')};
  }

  && > * > * {
    position: relative;
    min-height: calc(${fieldHeight} - ${size.stroke['stroke-default']} * 2);
  }

  && > * > *:has([aria-expanded='true']) {
    z-index: ${layout.zIndexDropdown};
  }

  && div:has(> button[aria-haspopup='listbox']) {
    position: static;
    flex: 1 0 auto;
    justify-content: center;
  }

  && [role='listbox'] {
    top: 100%;
    left: calc(-1 * ${size.stroke['stroke-default']});
    right: calc(-1 * ${size.stroke['stroke-default']});
  }
`;

export const FixedField = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  min-height: ${fieldHeight};
  padding: ${space['space-400']} ${space['space-500']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${radius('input', 'radius-md')};
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  color: ${semantic.text.primary};
`;
